import React from "react";
import { BrowserRouter } from "react-router-dom";
import { base_path } from "./environment.jsx";
import "./index.css";
import { createRoot } from "react-dom/client";
import { PersistGate } from "redux-persist/integration/react";

import { Provider } from "react-redux";
import store, { persistor } from "./core/redux/store.jsx";
import AllRoutes from "./Router/router.jsx";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { MediaLibraryProvider } from "./core/media-library/MediaLibraryProvider.jsx";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ThemeProvider } from "@/components/theme-provider";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
      retry: false,
    },
  },
});

import ErrorBoundary from "./components/ErrorBoundary.jsx";
import VersionUpdateChecker from "./components/VersionUpdateChecker.jsx";

// Auto-reload when dynamic import chunks fail due to a new deployment
window.addEventListener("vite:preloadError", (event) => {
  event?.preventDefault();
  window.location.reload();
});

const rootElement = document.getElementById("root");

if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <BrowserRouter basename={base_path}>
              <QueryClientProvider client={queryClient}>
                <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
                  <TooltipProvider>
                    <MediaLibraryProvider>
                      <VersionUpdateChecker />
                      <AllRoutes />
                    </MediaLibraryProvider>
                    <Toaster richColors closeButton position="top-right" />
                  </TooltipProvider>
                </ThemeProvider>
              </QueryClientProvider>
            </BrowserRouter>
          </PersistGate>
        </Provider>
      </ErrorBoundary>
    </React.StrictMode>,
  );
} else {
  console.error("Element with id 'root' not found.");
}
